<template>
  <v-carousel
    light
    hide-delimiters
    interval="100000"
    :style="{ height: '92vh' }"
  >
    <v-carousel-item v-for="(item,i) in items" :key="i">
      <component :is="item.src" />
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import slide1 from '@/components/home/slide1'
import slide2 from '@/components/home/slide2'
import slide3 from '@/components/home/slide3'

export default {
  components: {
    slide1,
    slide2,
    slide3
  },
  data () {
    return {
      items: [
        {
          src: slide1
        },
        {
          src: slide2
        },
        {
          src: slide3
        }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/home/carousel.vue